import LegalLayout from "@/pages/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout
      title="Terms & Conditions"
      updated="December 2025"
      lead="These Terms &amp; Conditions govern your use of craigmaloney.com and the tools and content provided by Craig Maloney Inc. By using the site, you agree to these terms."
      seo={{
        title: "Terms & Conditions | Craig Maloney Inc.",
        description:
          "The terms that govern use of craigmaloney.com and the tools provided by Craig Maloney Inc.",
        canonical: "https://craigmaloney.com/terms",
        og: {
          title: "Terms & Conditions | Craig Maloney Inc.",
          description: "Terms governing your use of craigmaloney.com.",
          type: "website",
          url: "https://craigmaloney.com/terms",
        },
      }}
      sections={[
        {
          heading: "Acceptance of Terms",
          paragraphs: [
            "By accessing or using the site, you agree to be bound by these terms and by our Privacy Policy. If you do not agree, please do not use the site.",
          ],
        },
        {
          heading: "Use of the Site",
          paragraphs: [
            "You may use the site for lawful business purposes only. You agree not to misuse the site, interfere with its operation, attempt unauthorized access, or use it in a way that could harm us or other users.",
          ],
        },
        {
          heading: "Tools, Reports & No Guarantees",
          paragraphs: [
            "Our assessment, strategy, and related tools produce directional guidance generated from the inputs you provide and automated systems. Outputs are for informational purposes only, are not professional, financial, legal, or valuation advice, and do not guarantee any particular result. You are responsible for decisions you make based on them.",
          ],
        },
        {
          heading: "Intellectual Property",
          paragraphs: [
            "The site and its content, design, and software are owned by Craig Maloney Inc. or its licensors and are protected by applicable laws. You may not copy, reproduce, or distribute the content without permission. Content and inputs you submit remain yours; you grant us permission to use them to provide the services.",
          ],
        },
        {
          heading: "Third-Party Links & Services",
          paragraphs: [
            "The site may link to third-party sites and rely on third-party services. We are not responsible for the content, policies, or practices of third parties.",
          ],
        },
        {
          heading: "Disclaimers",
          paragraphs: [
            "The site and its tools are provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind, express or implied, including merchantability, fitness for a particular purpose, and non-infringement, to the fullest extent permitted by law.",
          ],
        },
        {
          heading: "Limitation of Liability",
          paragraphs: [
            "To the maximum extent permitted by law, Craig Maloney Inc. will not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or data, arising from your use of the site or its tools.",
          ],
        },
        {
          heading: "Indemnification",
          paragraphs: [
            "You agree to indemnify and hold Craig Maloney Inc. harmless from claims, damages, and expenses arising from your use of the site or your violation of these terms.",
          ],
        },
        {
          heading: "Governing Law",
          paragraphs: [
            "These terms are governed by the laws of the State of California, without regard to its conflict-of-laws rules. Any disputes will be handled in the courts located in Orange County, California.",
          ],
        },
        {
          heading: "Changes to These Terms",
          paragraphs: [
            "We may update these terms from time to time. Continued use of the site after changes take effect constitutes acceptance of the updated terms.",
          ],
        },
        {
          heading: "Contact",
          paragraphs: [
            "Questions about these terms can be directed to Craig Maloney Inc. through the contact options on craigmaloney.com.",
          ],
        },
      ]}
    />
  );
}
